import State from './state';

export function getProblemList(state) {
  return state.problem_list;
}
export function getCauseList(state) {
  return state.cause_list;
}
export function getChangeList(state) {
  return state.change_list;
}
export function getSkillList(state) {
  return state.skill_list;
}
export function getSkillDescription(state) {
  return state.skill_description;
}
export function getConfigList(state) {
  return state.config_list;
}

export function configurationById(state = State) {
  return (configurationId) =>
    state.config_list.find(
      (configuration) => Number(configuration.id) === Number(configurationId),
    ) || {};
}

export function getCriterionValues(state) {
  return (childId) => {
    if (childId in state.criterionValues) {
      return state.criterionValues[childId];
    } else {
      return [];
    }
  };
}
export function getTipsList(state) {
  return state.tips_list;
}
export function getSkillTipsList(state) {
  return state.skill_tips_list;
}
export function quickTipsPopups(state = State) {
  return state.popup;
}

export function getChangesByCategory(state) {
  return state.changesByCategory;
}
